export const formatThinkingDuration = (startMs: number, endMs: number): string => {
  const seconds = Math.max(0, Math.round((endMs - startMs) / 1000));

  if (seconds < 60) {
    return `Thought for ${seconds}s`;
  }

  if (seconds < 120) {
    return 'Thought for 1 minute';
  }

  const minutes = Math.round(seconds / 60);

  return `Thought for ${minutes} minutes`;
};
